import { call, fork, put, takeLatest } from 'redux-saga/effects';

import * as types from '../constants/actionTypes';
import actions from '../actions';
import api from '../lib/api';
import notify from '../lib/notify';

export function* uploadDocumentSaga(action) {
  try {
    yield put(actions.form.uploadDocumentLoading());
    yield call(notify, { type: 'info', title: 'Uploading document...' });
    const response = yield call(api.s3.putS3, action.doc.mime, action.doc.data);
    yield put(actions.form.uploadDocumentSuccess());

    const recordToAdd = {
      name: action.doc.name,
      type: action.doc.type,
      url: response.uri,
      date: action.doc.date,
      size: response.size,
    };

    yield put(actions.form.addToGroup('documents', recordToAdd));
    yield call(notify, { type: 'success', title: 'Successfully uploaded document' });
  } catch (e) {
    yield put(actions.form.uploadDocumentError());
    yield call(notify, e);
  }
}

export function* watchUploadDocumentSaga() {
  yield takeLatest(types.UPLOAD_DOCUMENT, uploadDocumentSaga);
}

export default [
  fork(watchUploadDocumentSaga),
];
